export default function FacebookIcon() {
  return (
    <svg
      height="22px"
      width="22px"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 506.86 506.86"
    >
      <defs>
        <style>
          {`.cls-fb-1 {fill:#1877f2;}`}

          {`.cls-fb-2 {fill:#fff;}`}
        </style>
      </defs>

      <title>facebook-round-color</title>

      <path
        className="cls-fb-1"
        d="M506.86,253.43C506.86,113.46,393.39,0,253.43,0S0,113.46,0,253.43C0,379.92,92.68,484.77,213.83,503.78V326.69H149.48V253.43h64.35V197.6c0-63.52,37.84-98.6,95.72-98.6,27.73,0,56.73,5,56.73,5v62.36H334.33c-31.49,0-41.3,19.54-41.3,39.58v47.54h70.28l-11.23,73.26H293V503.78C414.18,484.77,506.86,379.92,506.86,253.43Z"
      />

      <path
        className="cls-fb-2"
        d="M352.08,326.69l11.23-73.26H293V205.89c0-20,9.81-39.58,41.3-39.58h31.95V104s-29-5-56.73-5c-57.88,0-95.72,35.08-95.72,98.6v55.83H149.48v73.26h64.35V503.78a256.11,256.11,0,0,0,79.2,0V326.69Z"
      />
    </svg>
  );
}
